<template>
  <el-form-item label-width="0" :prop="prop" :rules="handleRules">
    <el-select v-model.trim="innerValue" clearable @change="handleChange">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
  </el-form-item>
</template>

<script>
  import _ from 'lodash'
  import mixins from './mixins'
  import { getData } from '@/utils/dataSync'
  export default {
    name: 'VSelect',
    mixins: [mixins],
    data() {
      return {
        options: null,
        rules: [],
        innerValue: '',
      }
    },
    computed: {
      handleRules() {
        return this.explainValidate()
      },
    },
    mounted() {
      this.fetchData()
      this.innerValue = _.get(this.row, this.column.prop)
    },
    methods: {
      async fetchData() {
        let list = await getData({
          enableCache: this.config.enableCache || true,
          key: this.config.dataKey,
          dataType: this.config.dataType,
          requestParam: this.config.requestParam,
        })
        //filter

        this.options = []
        list.forEach((item) => {
          this.options.push({
            label: item[this.config.labelId],
            value: item[this.config.valueId],
          })
        })
      },
      handleChange(value) {
        _.set(this.row, this.column.prop, value)
        this.innerValue = value
        if (this.config.onChange) {
          //解析prop 获取到父表的行索引，以及目前所在的行索引
          this.config.onChange(
            this.tableRoot.tableData,
            this.row,
            this.column,
            this.prop.split('.'),
            value
          )
        }
      },
    },
  }
</script>
